import "@fortawesome/fontawesome-free/css/all.min.css";
import "filepond/dist/filepond.min.css";
import "./index.scss";

import * as React from "react";
import { AppProvider } from "./AppProvider";
import { ErrorBoundary } from "nsitools-react";
import { App } from "./App";
export interface IAppRootProps {}

const AppRoot: React.FunctionComponent<IAppRootProps> = (props) => {
  return (
    <ErrorBoundary>
      <AppProvider>
        <App />
      </AppProvider>
    </ErrorBoundary>
  );
};

export default AppRoot;
